// Module
var code = " <template><require from=\"./badge.scss\"></require><slot></slot></template> ";
// Exports
module.exports = code;